import React from 'react'
import { Grid, H, P } from '@farewill/ui'
import { useFormikContext } from 'formik'
import { FormikValues, quoteIsComplete } from './helpers'

const isReadyForConversion = (values: FormikValues) => {
  return quoteIsComplete({ values })
}

const ConvertCase = ({
  isReferredAndPaid,
}: {
  isReferredAndPaid: boolean
}): React.ReactElement => {
  const { values } = useFormikContext<FormikValues>()

  const showConversionMessage = isReadyForConversion(values)

  return (
    <Grid margin={['L', 0]}>
      <Grid.Item span={6}>
        <H size="S">Convert case</H>
        <Grid.Item margin={['M', 0]}>
          {showConversionMessage ? (
            <>
              {isReferredAndPaid && (
                <P>
                  This case is a redeemed funeral plan and no additional payment
                  is required.
                </P>
              )}
              <P>
                If the customer is happy for their loved one to be collected,
                convert the case and fill in fact find.
              </P>
            </>
          ) : (
            '↑ Complete sections above first'
          )}
        </Grid.Item>
      </Grid.Item>
    </Grid>
  )
}

export default ConvertCase
